import React from "react";
import fmeLogo from "../../images/fmeLogo.png";

const Loading = ({ isFadingOut }) => {
  return (
    <div
      className={`w-full h-screen bg-white flex justify-center items-center transition-opacity duration-500 ${
        isFadingOut ? "opacity-0" : "opacity-100"
      }`}
    >
      <img src={fmeLogo} alt="FME Logo" />
    </div>
  );
};

export default Loading;
